<template>
  <div>
    <div class="natMonitor-title">
      <div>{{ $t("alarms.network.nat.nat") }}</div>
    </div>
    <template>
      <Tabs size="small" :animated="false">
        <TabPane :label="$t('alarms.network.nat.natList')" name="tabInstance">
          <div class="natMonitor-top">
            <nat-monitor-search></nat-monitor-search>
          </div>
          <table-nat></table-nat>
        </TabPane>
      </Tabs>
    </template>
  </div>
</template>

<script>
import NatMonitorSearch from "../nat/NatMonitorSearch";
import TableNat from "../nat/TableNat";
export default {
  name: "NatMonitor",
  components: {
    NatMonitorSearch,
    TableNat,
  },
  data() {
    return {
      currentTab: "",
    };
  },
  methods: {},
};
</script>

<style scoped>
.natMonitor-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
.natMonitor-title > div:nth-child(1) {
  float: left;
}
.natMonitor-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.natMonitor-top {
  width: 100%;
  height: 32px;
  margin-bottom: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/network/nat/NatMonitor.vue